// import React from "react";
// import { useTranslation } from "react-i18next";
// const ViewItemService = ({ dataItem }) => {
//   const { t } = useTranslation();

//   console.log("data ==>", dataItem);
//   return (
//     <>
//       <div style={styles.container}>
//         {/* <h2 style={styles.title}>{data?.store_name}</h2> */}
//         <table style={styles.table}>
//           <tbody>
//             <tr style={{ borderBottom: "1px dotted black" }}>
//               <td>{t("Title")}</td>
//               <td>{t("Details")}</td>
//             </tr>
//             <tr style={{ background: "#e5e2e2" }}>
//               <td style={styles.label}>{t("Service Name")}:</td>
//               <td>{dataItem?.name}</td>
//             </tr>
//             <tr>
//               <td style={styles.label}>{t("Created At")}:</td>
//               <td>
//                 <td>{dataItem?.created_at}</td>
//               </td>
//             </tr>
//             {/* <tr style={{ background: "#e5e2e2" }}>
//               <td style={styles.label}>{t("Service Catagory")}:</td>
//               <td>{dataItem?.catagory}</td>
//             </tr> */}
//           </tbody>
//         </table>
//       </div>
//     </>
//   );
// };
// const styles = {
//   container: {
//     maxWidth: "50rem",
//     minWidth: "50rem",
//     margin: "auto",
//     padding: "20px",
//     // backgroundColor: "#f0f0f0",
//     borderRadius: "8px",
//     boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
//   },
//   title: {
//     textAlign: "center",
//     color: "#333",
//     marginBottom: "20px",
//   },
//   table: {
//     width: "100%",
//   },
//   label: {
//     fontWeight: "600",
//     paddingRight: "10px",
//     verticalAlign: "top",
//     padding: "1rem",
//   },
//   select: {
//     width: "100%",
//     padding: "8px",
//     borderRadius: "4px",
//     border: "1px solid #ccc",
//     fontSize: "14px",
//     marginTop: "5px",
//   },
// };

// export default ViewItemService;
import { background, color } from "@chakra-ui/system";
import { CONSTANTS } from "config/constant";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MdOutlineArrowBack } from "react-icons/md";
import { useTranslation } from "react-i18next";
import moment from "moment";

const ViewItemService = () => {
  const { t } = useTranslation();

  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state && location.state.data;
  function truncateText(text, maxLength) {
    if (text && text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  }

  return (
    <div className="flex gap-8">
      <div style={styles.container} className="min-h-[37rem]">
        <table style={styles.table}>
          <tbody>
            <div
              className="flex cursor-pointer items-center gap-2"
              onClick={() => {
                navigate(-1);
              }}
            >
              <MdOutlineArrowBack
                className="cursor-pointer"
                style={{ fontSize: "17px" }}
              />
              <p>Back</p>
            </div>
            <p className="mb-4 text-center text-[20px] font-semibold">
              View Item Services
            </p>
            <hr className="mb-4" />
            <div className="mb-3 flex justify-around">
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Service Name")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.name}
                </td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Created At")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {moment.unix(data?.created_at).format("DD/MM/YYYY")}
                </td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Service Catagory")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.catagory ? data?.catagory : "---"}
                </td>
              </tr>
            </div>
          </tbody>
        </table>
      </div>
    </div>
  );
};
const styles = {
  container: {
    margin: "auto",
    width: "80%",
    padding: "20px",
    background: "white",
    borderRadius: "8px",
    boxShadow: "box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
  },
  title: {
    textAlign: "center",
    marginBottom: "20px",
  },
  table: {
    width: "100%",
  },
  label: {
    paddingRight: "10px",
    verticalAlign: "top",
    padding: "1rem",
  },
};

export default ViewItemService;
